import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { paymentFormDivIds, paymentType } from "../../../constants";
import { paymentActions } from "../../../redux/actions";
import {
  getUserPayload,
  hyperpayFormCustomJS,
  renderPaymentform,
} from "../../../system";

const SaveCardModal = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const checkoutId = useSelector((state) => state.PaymentReducer.CheckoutID);
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );
  const [isLoadCustomJS, setLoadCustomJS] = useState(false);

  const userPayload = getUserPayload();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoadCustomJS) {
      hyperpayFormCustomJS(t, direction, false, false, true);
    }
    //eslint-disable-next-line
  }, [isLoadCustomJS]);

  useEffect(() => {
    if (props.isCenter) {
      dispatch(
        paymentActions.paymentCheckout({
          price: "12.00",
          paymentType: paymentType.SaveCard,
          centerId: userPayload?.user?.centerId,
          createRegistration: true,
        })
      );
    } else {
      dispatch(
        paymentActions.paymentCheckout({
          price: "12.00",
          paymentType: paymentType.SaveCard,
          systemUserId: userPayload?.user?.id,
          createRegistration: true,
        })
      );
    }
  }, []);

  useEffect(() => {
    if (checkoutId) {
      renderPaymentform(
        checkoutId,
        location.pathname,
        "?saveCard=true&tab=member&",
        paymentFormDivIds.addCardForm,
        setLoadCustomJS,
        true
      );
    }
  }, [checkoutId]);

  return (
    <>
      <div className="ViewHeader w-100">
        <p className="viewUserPara">{t(props.title)}</p>
      </div>
      <p className="horizentalLine" />
      {checkoutId && (
        <div id={paymentFormDivIds.addCardForm} className="pt-2"></div>
      )}
    </>
  );
};

export default SaveCardModal;
